import { useState } from "react";

export function ErrorMessage ({ title = null, message = null, width = "350px" }) {
    // const [isHidden, setIsHidden] = useState(true);

    return (
        <div className="card rounded-0 shadow-sm border-end-0 border-top-0 border-bottom-0 border-4 border-danger" style={{width: width, paddingTop: "10px", paddingLeft: "10px", paddingRight: "10px", fontSize: "14px"}}>
            <p>{title && <strong>{title}:</strong> } {message}</p>
        </div>
    );
}